module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-aai-student-image-2-f70c37d562a64e771246c81addd6a33b.jpg";